/**
 * An array of options for week duration.
 */
export const getWeekDurationOptions = [
  { label: '0', value: String(0) },
  { label: '1', value: String(1) },
  { label: '2', value: String(2) },
  { label: '3', value: String(3) },
];
